const toggler = document.getElementById('language-toggler');
const dropdown = document.getElementById('language-dropdown');
if(dropdown && toggler) {
    const handleClose = () => {
        dropdown.classList.remove("show");
        toggler.classList.remove('lang-list__show');
        document.body.removeEventListener('click', handleClose);
    }

    toggler.addEventListener('click', (e) => {
        e.stopPropagation();
        if(document.documentElement.getAttribute("dir") === "rtl") {
            dropdown.classList.replace('dropdown-menu-right', 'dropdown-menu-left')
        }
        dropdown.classList.toggle("show");
        toggler.classList.toggle('lang-list__show');
        document.body.addEventListener('click', handleClose);
    });

    dropdown.addEventListener('click', (e) => {
        e.stopPropagation();
    });
}




